import {
  ADD_SUPPLIER,
  ADD_SUPPLIER_COMPLETED,
  ADD_SUPPLIER_FAILED,
  GET_SUPPLIER,
  GET_SUPPLIER_COMPLETED,
  GET_SUPPLIER_FAILED,
  GET_SUPPLIERS,
  GET_SUPPLIERS_COMPLETED,
  GET_SUPPLIERS_FAILED,
  UPDATE_SUPPLIER,
  UPDATE_SUPPLIER_COMPLETED,
  UPDATE_SUPPLIER_FAILED,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_COMPLETED,
  DELETE_SUPPLIER_FAILED,
  SEARCH_SUPPLIERS,
  SEARCH_SUPPLIERS_COMPLETED,
  SEARCH_SUPPLIERS_FAILED,
  SHOW_DELETE_SUPPLIER_MODAL,
  HIDE_DELETE_SUPPLIER_MODAL,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  gettingSuppliers: false,
  suppliers: [],
  gettingSupplier: false,
  supplier: null,
  addingSupplier: false,
  updatingSupplier: false,
  deleteSupplierModalVisible: false,
  supplierToDelete: null,
  supplierDeleting: false,
  search: searchDefault,
};

const supplierReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_SUPPLIERS: return handleSearch(state, 'search', action.payload);
    case SEARCH_SUPPLIERS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_SUPPLIERS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_SUPPLIERS: {
      return {
        ...state,
        gettingSuppliers: true,
        suppliers: [],
      };
    }
    case GET_SUPPLIERS_COMPLETED: {
      return {
        ...state,
        gettingSuppliers: false,
        suppliers: action.payload.data,
      };
    }
    case GET_SUPPLIERS_FAILED: {
      return {
        ...state,
        gettingSuppliers: false,
      };
    }
    case GET_SUPPLIER: {
      return {
        ...state,
        gettingSupplier: true,
        supplier: null,
      };
    }
    case GET_SUPPLIER_COMPLETED: {
      return {
        ...state,
        gettingSupplier: false,
        supplier: action.payload,
      };
    }
    case GET_SUPPLIER_FAILED: {
      return {
        ...state,
        gettingSupplier: false,
      };
    }
    case ADD_SUPPLIER: {
      return {
        ...state,
        addingSupplier: true,
      };
    }
    case ADD_SUPPLIER_COMPLETED: {
      return {
        ...state,
        addingSupplier: false,
      };
    }
    case ADD_SUPPLIER_FAILED: {
      return {
        ...state,
        addingSupplier: false,
      };
    }
    case UPDATE_SUPPLIER: {
      return {
        ...state,
        updatingSupplier: true,
      };
    }
    case UPDATE_SUPPLIER_COMPLETED: {
      return {
        ...state,
        updatingSupplier: false,
      };
    }
    case UPDATE_SUPPLIER_FAILED: {
      return {
        ...state,
        updatingSupplier: false,
      };
    }
    case SHOW_DELETE_SUPPLIER_MODAL: {
      return {
        ...state,
        deleteSupplierModalVisible: true,
        supplierToDelete: action.payload,
      };
    }
    case HIDE_DELETE_SUPPLIER_MODAL: {
      return {
        ...state,
        deleteSupplierModalVisible: false,
        supplierToDelete: null,
      };
    }
    case DELETE_SUPPLIER: {
      return {
        ...state,
        supplierDeleting: true,
      };
    }
    case DELETE_SUPPLIER_COMPLETED: {
      return {
        ...state,
        supplierDeleting: false,
      };
    }
    case DELETE_SUPPLIER_FAILED: {
      return {
        ...state,
        supplierDeleting: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default supplierReducer;



// WEBPACK FOOTER //
// ./src/Supplier/reducer.js